import { GameTimelineEvent } from '@/services/communityService';

export interface TimelineLabelOptions {
  saveLabel?: string;
  foulLabel?: string;
}

/**
 * Returns a human-friendly display label for a game timeline event.
 * Replaces complex nested ternary conditions across GameDetailModal and MabarRekapPage.
 */
export function getTimelineEventLabel(
  event: GameTimelineEvent,
  assistName?: string | null,
  options?: TimelineLabelOptions
): string {
  if (event.type === 'own_goal' || event.detail === 'own_goal') {
    return 'Gol Bunuh Diri (OG)';
  }

  if (event.type === 'goal') {
    return assistName ? `Assist: ${assistName}` : 'Gol';
  }

  switch (event.type) {
    case 'save':
      return options?.saveLabel ?? 'Crucial Save';
    case 'foul':
      if (event.detail === 'yellow_card') return 'Kartu Kuning';
      if (event.detail === 'red_card') return 'Kartu Merah';
      return event.detail || (options?.foulLabel ?? 'Pelanggaran');
    case 'yellow_card':
      return 'Kartu Kuning';
    case 'red_card':
      return 'Kartu Merah';
    case 'key_pass':
      return 'Key Pass';
    case 'clearance':
      return 'Clearance';
    case 'freestyle':
      return 'Freestyle';
    default:
      return event.detail || event.type;
  }
}
